// extracted by mini-css-extract-plugin
module.exports = {"page":"page___1jArj","container":"container___PCilO","rules":"rules___22vGD"};